export default __webpack_public_path__ + "static/media/else.351a8628.svg";